<div class="card mt-3" *ngIf="participants?.length">

  <div class="card-header fw-bold">
    Liste des participants
  </div>

  <div class="card-body p-0">

    <!-- 🖥 TABLE – Desktop -->
    <div class="d-none d-md-block">
      <table class="table table-hover mb-0">

        <thead class="table-light">
          <tr>
            <th>Nom</th>
            <th>Téléphone</th>
            <th>Statut</th>
            <th>Infos</th>
            <th class="text-end">Actions</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let p of participants; trackBy: trackById">
            <td>{{ p.fullName }}</td>
            <td>{{ p.phone }}</td>
            <td>{{ p.status }}</td>

            <td>
              <span *ngIf="p.diplomaFile"><i class="icofont-file-pdf"></i> Diplôme</span>
              <span *ngIf="p.matriculeNumber"><i class="icofont-info"></i> {{p.matriculeNumber}}</span>
            </td>

            <td class="text-end">
              <button type="button" class="btn action btn-sm btn-outline-secondary me-2" (click)="edit.emit(p)">
                <i class="icofont-edit-alt"></i>
              </button>

              <button type="button" class="btn action btn-sm btn-outline-danger" (click)="remove.emit(p.id)">
                <i class="icofont-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>

      </table>
    </div>

    <!-- 📱 CARDS – Mobile -->
    <div class="d-block d-md-none p-3">
      <div class="participant-card mb-3" *ngFor="let p of participants; trackBy: trackById">

        <div class="fw-bold mb-1">Nom: {{ p.fullName }}</div>

        <div class="small text-muted mb-1">
          <i class="icofont-phone"></i> Tél: {{ p.phone }}
        </div>

        <div class="mb-2">
          <span class="badge bg-secondary status">{{ p.status }}</span>
        </div>

        <div class="mb-2">
          <span *ngIf="p.diplomaFile"><i class="icofont-file-pdf"></i> Diplôme</span>
          <span *ngIf="p.matriculeNumber"><i class="icofont-info"></i> Matricule: {{p.matriculeNumber}}</span>
        </div>

        <div class="text-end">
          <button type="button" class="btn action btn-sm btn-outline-secondary me-2" (click)="edit.emit(p)">
            <i class="icofont-edit-alt"></i>
          </button>

          <button type="button" class="btn action btn-sm btn-outline-danger" (click)="remove.emit(p.id)">
            <i class="icofont-trash"></i>
          </button>
        </div>

      </div>
    </div>

  </div>
</div>